export const SERVICE_WITHOUT_ACT_REQUEST_GET_REQUEST =
  "SERVICE_WITHOUT_ACT_REQUEST_GET_REQUEST";
export const SERVICE_WITHOUT_ACT_REQUEST_GET_SUCCESS =
  "SERVICE_WITHOUT_ACT_REQUEST_GET_SUCCESS";
export const SERVICE_WITHOUT_ACT_REQUEST_GET_ERROR =
  "SERVICE_WITHOUT_ACT_REQUEST_GET_ERROR";
export const SERVICE_WITHOUT_ACT_REQUEST_GET_BY_KEY_REQUEST =
  "SERVICE_WITHOUT_ACT_REQUEST_GET_BY_KEY_REQUEST";
export const SERVICE_WITHOUT_ACT_REQUEST_GET_BY_KEY_SUCCESS =
  "SERVICE_WITHOUT_ACT_REQUEST_GET_BY_KEY_SUCCESS";
export const SERVICE_WITHOUT_ACT_REQUEST_GET_BY_KEY_ERROR =
  "SERVICE_WITHOUT_ACT_REQUEST_GET_BY_KEY_ERROR";
export const SERVICE_WITHOUT_ACT_REQUEST_ADD_REQUEST =
  "SERVICE_WITHOUT_ACT_REQUEST_ADD_REQUEST";
export const SERVICE_WITHOUT_ACT_REQUEST_ADD_SUCCESS =
  "SERVICE_WITHOUT_ACT_REQUEST_ADD_SUCCESS";
export const SERVICE_WITHOUT_ACT_REQUEST_ADD_ERROR =
  "SERVICE_WITHOUT_ACT_REQUEST_ADD_ERROR";
export const SERVICE_WITHOUT_ACT_REQUEST_EDIT_REQUEST =
  "SERVICE_WITHOUT_ACT_REQUEST_EDIT_REQUEST";
export const SERVICE_WITHOUT_ACT_REQUEST_EDIT_SUCCESS =
  "SERVICE_WITHOUT_ACT_REQUEST_EDIT_SUCCESS";
export const SERVICE_WITHOUT_ACT_REQUEST_EDIT_ERROR =
  "SERVICE_WITHOUT_ACT_REQUEST_EDIT_ERROR";
export const SERVICE_WITHOUT_ACT_REQUEST_DELETE_REQUEST =
  "SERVICE_WITHOUT_ACT_REQUEST_DELETE_REQUEST";
export const SERVICE_WITHOUT_ACT_REQUEST_DELETE_SUCCESS =
  "SERVICE_WITHOUT_ACT_REQUEST_DELETE_SUCCESS";
export const SERVICE_WITHOUT_ACT_REQUEST_DELETE_ERROR =
  "SERVICE_WITHOUT_ACT_REQUEST_DELETE_ERROR";

export const SERVICE_WITHOUT_ACT_REQUEST_WORKFLOW_UPDATE_REQUEST =
  "SERVICE_WITHOUT_ACT_REQUEST_WORKFLOW_UPDATE_REQUEST";
export const SERVICE_WITHOUT_ACT_REQUEST_WORKFLOW_UPDATE_SUCCESS =
  "SERVICE_WITHOUT_ACT_REQUEST_WORKFLOW_UPDATE_SUCCESS";
export const SERVICE_WITHOUT_ACT_REQUEST_WORKFLOW_UPDATE_ERROR =
  "SERVICE_WITHOUT_ACT_REQUEST_WORKFLOW_UPDATE_ERROR";
